/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * authentication_service
 * OpenAPI spec version: 0.1.0
 */

/**
 * A language the app's interface is available in, as a BCP 47 tag.
 */
export type Language = (typeof Language)[keyof typeof Language];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const Language = {
  en: 'en',
  de: 'de',
  fr: 'fr',
  es: 'es',
  it: 'it',
  nl: 'nl',
  'pt-PT': 'pt-PT',
  sv: 'sv',
  da: 'da',
  nb: 'nb',
  fi: 'fi',
  pl: 'pl',
  ru: 'ru',
  ja: 'ja',
  ko: 'ko',
  'zh-Hans': 'zh-Hans',
  'zh-Hant': 'zh-Hant',
  hi: 'hi',
  id: 'id',
  vi: 'vi',
  th: 'th',
} as const;
